export function timeAgo(value) {
  if (!value) return "never";
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return "never";
  const seconds = Math.floor((Date.now() - then) / 1000);
  if (seconds < 45) return "just now";
  if (seconds < 90) return "a minute ago";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minutes ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours === 1 ? "an hour ago" : `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return days === 1 ? "yesterday" : `${days} days ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return months === 1 ? "a month ago" : `${months} months ago`;
  return `${Math.floor(months / 12)} years ago`;
}

export function fullDate(value) {
  if (!value) return "\u2014";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "\u2014";
  return d.toLocaleString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function plural(n, word, suffix = "s") {
  return `${n} ${word}${n === 1 ? "" : suffix}`;
}

export function maskEmail(email) {
  if (!email || !email.includes("@")) return email || "";
  const [name, domain] = email.split("@");
  const head = name.slice(0, 2);
  return `${head}${"\u2022".repeat(Math.max(2, name.length - 2))}@${domain}`;
}

export function personLabel(entry) {
  if (!entry) return "Someone";
  if (entry.actor_role === "system" || entry.actor === "system") return "System";
  if (entry.actor_name) return entry.actor_name;
  if (entry.actor_role === "agency_admin") return "Agency";
  return entry.actor || "Someone";
}

export function valueToText(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string") return item;
        if (!item) return "";
        return [item.question, item.answer, item.title, item.body, item.caption, item.alt]
          .filter(Boolean)
          .join(" \u2014 ");
      })
      .join("\n");
  }
  return String(value);
}

export function isEmptyValue(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) {
    if (!value.length) return true;
    return value.every((item) =>
      typeof item === "string"
        ? !item.trim()
        : !Object.entries(item || {}).some(([k, v]) => k !== "image" && String(v || "").trim()),
    );
  }
  return false;
}

export function sameValue(a, b) {
  return JSON.stringify(normalise(a)) === JSON.stringify(normalise(b));
}

function normalise(v) {
  if (typeof v === "string") return v.replace(/[ \t]+/g, " ").trim();
  if (Array.isArray(v)) return v.map(normalise);
  if (v && typeof v === "object") {
    return Object.keys(v)
      .sort()
      .reduce((acc, k) => {
        acc[k] = normalise(v[k]);
        return acc;
      }, {});
  }
  return v;
}
